(function () {
  var root = document.querySelector('[data-pz-root]');
  if (!root) return;

  function wrapEvery30(text) {
    var words = text.split(' ');
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      if (current === '') {
        current = word;
      } else if ((current + ' ' + word).length <= 30) {
        current += ' ' + word;
      } else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    return lines.slice(0, 3).join('\n');
  }

  var trigger = document.querySelector('[data-pz-trigger]');
  var overlay = document.querySelector('[data-pz-overlay]');
  var closeBtn = root.querySelector('[data-pz-close]');

  document.body.appendChild(overlay);
  document.body.appendChild(root);

  var lockedScrollY = 0;

  function getCurrentVariantId() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var input = form && (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'));
    return (input && input.value) || state.mainVariantId;
  }

  function syncVariant() {
    var freshId = getCurrentVariantId();
    if (!freshId || freshId === state.mainVariantId) return;
    state.mainVariantId = freshId;
    fetch(window.location.pathname + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variant = data.variants.find(function (v) { return String(v.id) === String(freshId); });
        if (variant) {
          state.basePrice = variant.price / 100;
          updateTotal();
        }
      });
  }

  function openDrawer() {
    lockedScrollY = window.scrollY;
    syncVariant();
    root.style.visibility = 'visible';
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTimeout(function () {
      root.style.visibility = 'hidden';
    }, 250);
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var state = {
    mainVariantId: root.dataset.mainVariantId,
    basePrice: parseFloat(root.dataset.basePrice),
    priority: false,
    review: true,
    note: false
  };

  var addons = {
    bothsides: { id: root.dataset.bothsidesVariantId, price: parseFloat(root.dataset.bothsidesPrice) },
    priority: { id: root.dataset.priorityVariantId, price: parseFloat(root.dataset.priorityPrice) },
    review: { id: root.dataset.reviewVariantId, price: parseFloat(root.dataset.reviewPrice) },
    note: { id: root.dataset.noteVariantId, price: parseFloat(root.dataset.notePrice) }
  };

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  function createEngraveUnit(key, label) {
    var group = root.querySelector('[data-pz-unit="' + key + '"]');
    var colorGroup = group.querySelector('[data-pz-pills="color"]');
    var fontGroup = group.querySelector('[data-pz-pills="font"]');
    var outerInput = group.querySelector('[data-pz-field="engrave-outer"]');
    var innerInput = group.querySelector('[data-pz-field="engrave-inner"]');
    var innerGroup = group.querySelector('[data-pz-engrave-inner]');
    var charOuter = group.querySelector('[data-pz-charcount="outer"]');
    var charInner = group.querySelector('[data-pz-charcount="inner"]');
    var previewWrapOuter = group.querySelector('[data-pz-preview-wrap="outer"]');
    var previewWrapInner = group.querySelector('[data-pz-preview-wrap="inner"]');
    var previewTextOuter = group.querySelector('[data-pz-preview="outer"]');
    var previewTextInner = group.querySelector('[data-pz-preview="inner"]');
    var bothsidesToggle = group.querySelector('[data-pz-toggle="bothsides"]');
    var errorEl = group.querySelector('[data-pz-error]');

    var unit = {
      color: 'Ασημένιο',
      font: 'Classic',
      bothsides: false
    };

    function updatePreview(which) {
      if (which === 'outer' || !which) {
        var textOuter = outerInput.value.trim();
        previewTextOuter.textContent = wrapEvery30(textOuter);
        previewWrapOuter.hidden = textOuter.length === 0;
      }
      if (which === 'inner' || !which) {
        var textInner = innerInput.value.trim();
        previewTextInner.textContent = wrapEvery30(textInner);
        previewWrapInner.hidden = !unit.bothsides || textInner.length === 0;
      }
    }

    colorGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('.pz__pill');
      if (!btn) return;
      colorGroup.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      unit.color = btn.dataset.value;
    });

    fontGroup.addEventListener('click', function (e) {
      var btn = e.target.closest('.pz__pill');
      if (!btn) return;
      fontGroup.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
      btn.classList.add('is-active');
      unit.font = btn.dataset.value;
      previewTextOuter.style.fontFamily = btn.style.fontFamily;
      previewTextInner.style.fontFamily = btn.style.fontFamily;
    });

    outerInput.addEventListener('input', function () {
      charOuter.textContent = outerInput.value.length + '/90';
      updatePreview('outer');
    });

    innerInput.addEventListener('input', function () {
      charInner.textContent = innerInput.value.length + '/90';
      updatePreview('inner');
    });

    bothsidesToggle.addEventListener('change', function () {
      unit.bothsides = bothsidesToggle.checked;
      innerGroup.hidden = !unit.bothsides;
      if (!unit.bothsides) {
        innerInput.value = '';
        charInner.textContent = '0/90';
      }
      updatePreview('inner');
      updateTotal();
    });

    return {
      get sidePrice() { return unit.bothsides ? addons.bothsides.price : 0; },
      get isBothSides() { return unit.bothsides; },
      validate: function () {
        errorEl.hidden = true;
        var outerVal = outerInput.value.trim();
        var innerVal = innerInput.value.trim();
        if (!outerVal) {
          errorEl.textContent = 'Συμπλήρωσε το κείμενο χάραξης.';
          errorEl.hidden = false;
          outerInput.focus();
          return false;
        }
        if (unit.bothsides && !innerVal) {
          errorEl.textContent = 'Συμπλήρωσε το κείμενο χάραξης για τη 2η πλευρά.';
          errorEl.hidden = false;
          innerInput.focus();
          return false;
        }
        return true;
      },
      properties: function () {
        var props = {};
        props[label + ' - Χρώμα'] = unit.color;
        props[label + ' - Γραμματοσειρά'] = unit.font;
        props[label + ' - Χάραξη'] = outerInput.value.trim();
        if (unit.bothsides) props[label + ' - Επιπλέον Χάραξη - 2η Πλευρά'] = innerInput.value.trim();
        return props;
      }
    };
  }

  var unitA = createEngraveUnit('a', 'Μπρελόκ 1');
  var unitB = createEngraveUnit('b', 'Μπρελόκ 2');

  var priorityToggle = root.querySelector('[data-pz-toggle="priority"]');
  priorityToggle.addEventListener('change', function () {
    state.priority = priorityToggle.checked;
    updateTotal();
  });

  var reviewToggle = root.querySelector('[data-pz-toggle="review"]');
  reviewToggle.addEventListener('change', function () {
    state.review = reviewToggle.checked;
    updateTotal();
  });

  var noteToggle = root.querySelector('[data-pz-toggle="note"]');
  noteToggle.addEventListener('change', function () {
    state.note = noteToggle.checked;
    updateTotal();
  });

  function updateTotal() {
    var total = state.basePrice + unitA.sidePrice + unitB.sidePrice;
    if (state.priority) total += addons.priority.price;
    if (state.review) total += addons.review.price;
    if (state.note) total += addons.note.price;
    root.querySelector('[data-pz-total]').textContent = formatMoney(total);
  }

  var errorGeneral = root.querySelector('[data-pz-error-general]');
  var submitBtn = root.querySelector('[data-pz-submit]');

  function showGeneralError(msg) {
    errorGeneral.textContent = msg;
    errorGeneral.hidden = false;
  }

  submitBtn.addEventListener('click', function () {
    errorGeneral.hidden = true;
    if (!unitA.validate()) return;
    if (!unitB.validate()) return;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Προσθήκη...';

    var properties = Object.assign({}, unitA.properties(), unitB.properties());
    var notesVal = root.querySelector('[data-pz-field="notes"]').value.trim();
    if (notesVal) properties['Παρατηρήσεις - Σχόλια'] = notesVal;

    var items = [];
    items.push({
      id: getCurrentVariantId(),
      quantity: 1,
      properties: properties
    });

    var bothSidesCount = (unitA.isBothSides ? 1 : 0) + (unitB.isBothSides ? 1 : 0);
    if (bothSidesCount > 0) items.push({ id: addons.bothsides.id, quantity: bothSidesCount });
    if (state.priority) items.push({ id: addons.priority.id, quantity: 1 });
    if (state.review) items.push({ id: addons.review.id, quantity: 1 });
    if (state.note) items.push({ id: addons.note.id, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showGeneralError('Κάτι πήγε στραβά. Δοκίμασε ξανά.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      });
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      errorGeneral.hidden = true;
    }
  });

  updateTotal();
})();
